import React, { useState } from 'react'
import './MakroHead.scss'
import { ReactComponent as BurgerIcon } from '../../components/assets/MakroPage/BurgerMakroHead.svg'
import { ReactComponent as CarIcon } from '../../components/assets/MakroPage/CarMakroHead.svg'
import { ReactComponent as ZoomIcon } from '../../components/assets/MakroPage/ZoomIcon.svg'


const MakroHead = ({ setOpenFilter, setIsCartOpen, setFilters, filters }) => {

  return (
    <div className="MakroHead">
      <div className='Burger' onClick={() => setOpenFilter(true)}>
        <BurgerIcon />
      </div>
      <div className="Search">
        <input 
          type="text"
          className='Search__input'
          value={filters?.search}
          placeholder='Search...'
          onChange={(e) => {setFilters((prew) => ({...prew, search: e.target.value }))}}
        />
        <ZoomIcon />
      </div>
      <div className='Cart' onClick={() => setIsCartOpen(true)}>
        <CarIcon width={24} height={24}/>
      </div>
    </div>
  )
}

export default MakroHead